const MasterChecklist = {
    "master_checklist": "Checklist",

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "list_title": "Checklist",
    "filter_title": "Checklist Filter",

    // TABLE HEADER
    "table_name": "Name",
    "table_description": "Description",

    // ERROR
    "error_name": "Enter Checklist Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",
}

export default MasterChecklist;
